import React from "react";
import { ActionIcon } from "@mantine/core";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";

function SectionControl({
	label,
	hasRecords,
	count,
	displayValue,
	emptyLabel = "no records",
	emptyColor = "#bbb",
}) {
	const hasData = count != null ? count > 0 : hasRecords;
	return (
		<span style={{ display: "flex", alignItems: "center", gap: 8 }}>
			{label}
			{displayValue ? (
				<span
					style={{
						fontWeight: 400,
						color: "#888",
						fontFamily: "monospace",
					}}
				>
					({displayValue})
				</span>
			) : count != null && count > 0 ? (
				<span
					style={{
						fontWeight: 400,
						color: "#888",
						fontFamily: "monospace",
					}}
				>
					({count})
				</span>
			) : !hasData ? (
				<span
					style={{
						fontWeight: 400,
						color: emptyColor,
						fontSize: 12,
						fontStyle: "italic",
					}}
				>
					{emptyLabel}
				</span>
			) : null}
		</span>
	);
}

// onToggle omitted => pane is always expanded with no collapse affordance
function ColumnPane({
	title,
	sectionControl,
	collapsed = false,
	onToggle,
	isLast,
	children,
}) {
	const collapsible = typeof onToggle === "function";

	return (
		<div
			style={{
				width: collapsed ? 32 : undefined,
				flex: collapsed ? undefined : 1,
				flexShrink: collapsed ? 0 : undefined,
				display: "flex",
				flexDirection: "column",
				borderRight: isLast ? "none" : "1px solid #e0e0e0",
				overflow: "hidden",
				minWidth: 0,
			}}
		>
			<div
				style={{
					display: "flex",
					flexDirection: collapsed ? "column" : "row",
					alignItems: "center",
					justifyContent: collapsed ? "center" : "space-between",
					padding: collapsed ? "6px 0" : "4px 8px",
					borderBottom: "1px solid #e0e0e0",
					flexShrink: 0,
					cursor: collapsible ? "pointer" : "default",
					background: "#fafafa",
					gap: 4,
				}}
				onClick={collapsible ? onToggle : undefined}
			>
				{collapsed ? (
					<>
						<ActionIcon variant="subtle" size="sm" component="div">
							<IconChevronRight size={14} />
						</ActionIcon>
						<span
							style={{
								fontSize: 11,
								color: "#555",
								textTransform: "uppercase",
								letterSpacing: "0.06em",
								writingMode: "vertical-rl",
								marginTop: 4,
							}}
						>
							{title}
						</span>
					</>
				) : (
					<>
						<span style={{ fontWeight: 600, fontSize: 13 }}>
							{sectionControl}
						</span>
						{collapsible ? (
							<ActionIcon
								variant="subtle"
								size="sm"
								component="div"
							>
								<IconChevronLeft size={14} />
							</ActionIcon>
						) : null}
					</>
				)}
			</div>
			{!collapsed ? (
				<div style={{ flex: 1, overflow: "auto", padding: "4px 8px" }}>
					{children}
				</div>
			) : null}
		</div>
	);
}

export { ColumnPane, SectionControl };
